// @ts-nocheck
/* eslint-disable */
import {
  takeLatest,
  take,
  call,
  put,
  fork,
  cancel,
  select,
} from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import * as types from 'appRedux/actions/register';
import { API_URL as API_URI } from 'config/constants';
import { fetchPostApi, fetchGetApi } from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';

function* requestRegister(action) {
  const { payload } = action;

  const data = yield call(fetchPostApi, `${API_URI}/user/register`, payload);

  if (data) {
    yield put({ type: types.REGISTER_USER_SUCCESS, payload: data });
    router.navigate('/login');
    successToast(data.message);
  }
}

function* getPermissionRoles() {
  const data = yield call(fetchGetApi, `${API_URI}/roles/list`);

  if (data) {
    yield put({ type: types.GET_PERMISSION_ROLE_SUCCESS, payload: data });
  }
}
function* registerWatcher() {
  yield takeLatest(types.GET_PERMISSION_ROLE_REQUEST, getPermissionRoles);
  yield takeLatest(types.REGISTER_USER_REQUEST, requestRegister);
}

export default registerWatcher;
